import ApiService from '../util/api';

export function update() {}

export function getNav() {
  return () => ApiService
    .get('/web-api/v1/nav/get/', {}, {}, 'text')
    .then(text => text);
}



// WEBPACK FOOTER //
// ./src/actions/NavActions.js